import { render, staticRenderFns } from "./ProfilePreview.vue?vue&type=template&id=b550a016&"
import script from "./ProfilePreview.vue?vue&type=script&lang=ts&"
export * from "./ProfilePreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports